var exports = {
  "k": "x93eb46d8--f6cfec--container",
  "v": "x93eb46d8--f6cfec--container-phone",
};

module.exports = exports;
